import { Box, Button, Typography } from "@mui/material";
import React from "react";
import theme from "../../../../utils/theme";
import "../../ActivateSubscription.css";
const PremiumListing = () => {
  return (
    <div
      style={{
        marginTop: "1rem",
        marginBottom: "10rem",
        width: "100%",
        border: "solid 3px #B1E2DB",
        borderRadius: "20px",
        paddingTop: "10px",
        paddingRight:"10px"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
        }}
      >
        <img src="/images/Diamond.png" alt="not found" />
        <h4>Premium Plan</h4>
      </div>

      <div
        style={{
          display: "flex",
          paddingLeft: "15px",
        }}
      >
        <Button
          variant="contained"
          style={{
            backgroundColor: theme.palette.primary.main,
            borderRadius: "10px",
            marginTop: "1rem",
          }}
        >
          Benefits
        </Button>
      </div>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            flexDirection: "column",
            marginTop: "1rem",
            marginBottom: "1rem",
            paddingLeft: "1rem",
          }}
        >
          <Box className="Box-container">
            <Box className="listing"></Box>Shop Name
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>Place
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>Shop Image
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>Category
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>All Address
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>Phone number
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>Google location
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>Email
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>Banner Image
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>
            WhatsApp Facebook & etc...
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>About Us
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>
            Add up to 10 Service details
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>
            Add up to 12 Images in Catalogue
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>
            Add up to 8 Images in Cover
          </Box>
          <Box className="Box-container">
            <Box sx={{paddingLeft:"10px"}}></Box>
            &#128312; &#128312; &#128312; &#128312; &#128312;
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>
            Facebook page promotion
          </Box>
          <Box className="Box-container">
            <Box className="listing"></Box>
          Banner image (in home page)
          </Box>
        </div>
        <div
          style={{
          
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
           <Box className="typo_container">
            <Typography className="typo_box_old">
              ₹ <Typography className="typo_old">3600 </Typography>
            </Typography>
            <Typography className="typo_box">
              ₹ <Typography  className="typo-new">1800 </Typography>
            </Typography>
          </Box>
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.palette.primary.main,
              borderRadius: "10px",
              marginTop: "1rem",
              width:"136px",
              textTransform:"none"
            }}
          >
            Activate Now
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default PremiumListing;
